import script from "./SeuProximoEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./SeuProximoEvento.vue?vue&type=script&setup=true&lang=js"

import "./SeuProximoEvento.vue?vue&type=style&index=0&id=7b6d83ec&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b6d83ec"]])

export default __exports__